import {Bytes} from "../io/Bytes"
import {BaseCode} from "./BaseCode"
import {Register} from "../../genes/Register"

/**
Allows one to encode/decode String and bytes using Base64 encoding.
*/
export const Base64 = Register.global("$hxClasses")["haxe.crypto.Base64"] = 
class Base64 {
	static encode(bytes, complement = true) {
		let str = new BaseCode(Base64.BYTES).encodeBytes(bytes).toString();
		if (complement) {
			switch (bytes.length % 3) {
				case 1:
					str += "==";
					break
				case 2:
					str += "=";
					break
				default:
				
			};
		};
		return str;
	}
	static get __name__() {
		return "haxe.crypto.Base64"
	}
	get __class__() {
		return Base64
	}
}


Base64.CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
Base64.BYTES = Bytes.ofString(Base64.CHARS)